import React from 'react';

// Loading indicators for the national job search (owner 2026-10-02): a spinner wherever /jobs loads
// data, holding the space so the page doesn't jump. Same idea as the boards' src/components/Spinner.jsx.
export function Spinner({ label = 'Loading…', className = 'h-8 w-8' }) {
  return (
    <span role="status" className="inline-flex items-center">
      <svg className={`animate-spin text-primary ${className}`} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
        <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      </svg>
      <span className="sr-only">{label}</span>
    </span>
  );
}

export function LoadingBlock({ label = 'Loading jobs…', minHeight = 'min-h-[16rem]' }) {
  return (
    <div className={`flex w-full flex-col items-center justify-center gap-3 ${minHeight}`} aria-busy="true">
      <Spinner label={label} className="h-10 w-10" />
      <p className="text-sm font-medium text-slate-500" aria-hidden="true">
        {label}
      </p>
    </div>
  );
}

// Over results that are being replaced (new filter or page): they stay put, dimmed, with a spinner on top.
export function LoadingOverlay({ label = 'Loading jobs…' }) {
  return (
    <div className="absolute inset-0 z-20 flex justify-center rounded-xl bg-white/50" aria-busy="true">
      <div className="sticky top-24 mt-8 flex h-fit items-center gap-3 rounded-full bg-white px-5 py-3 shadow-lg ring-1 ring-slate-200">
        <Spinner label={label} className="h-6 w-6" />
        <span className="text-sm font-semibold text-slate-700" aria-hidden="true">
          {label}
        </span>
      </div>
    </div>
  );
}
